import React, { ReactNode } from 'react';
import styled from 'styled-components';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import { useHistory } from 'react-router-dom';
import { Appointment } from 'kb-shared';
import LocationDetails from '../components/LocationDetails';
import StepDetail from './StepDetail';
import { YellowButton } from '../../../components/Buttons';
import { EnvironmentType } from 'kb-shared';
interface Props {
  appointmentFilter: (appt: Appointment, env: EnvironmentType) => boolean;
  apptTypeId: number | null;
  description: ReactNode;
  hideBook?: boolean;
}

const PATIENT_APPOINTMENTS = gql`
  query appointments {
    appointments: journeyAppointments {
      id
      location {
        id
        address
        name
        patientFacing
        timeZone
      }
      startTime
      endTime
      appointmentType {
        id
      }
    }
  }
`;

const AppointmentDetail = ({ apptTypeId, appointmentFilter, description, hideBook }: Props) => {
  const history = useHistory();

  const { loading, data } = useQuery(PATIENT_APPOINTMENTS);
  if (loading || !data) {
    return null;
  }
  const appointment = data.appointments.find((appt: Appointment) =>
    appointmentFilter(appt, process.env.REACT_APP_ENV)
  );
  return (
    <StepDetail>
      <FlexContainer>
        <Description>{description}</Description>
        {!appointment && !hideBook && (
          <Button onClick={() => history.push(`/book?step=location&appointment_id=${apptTypeId}`)}>
            Book an Appointment
          </Button>
        )}
      </FlexContainer>
      {appointment && <LocationDetails location={appointment.location} />}
    </StepDetail>
  );
};

export default AppointmentDetail;

const FlexContainer = styled.div`
  display: flex;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.smallDesktop}) {
    flex-wrap: wrap;
  }
`;

const Button = styled(YellowButton)`
  min-width: fit-content;
  height: fit-content;
`;

const Description = styled.div`
  p {
    margin-top: 20px;
  }
  p:first-of-type {
    margin-top: 0;
  }
`;
